import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TK3224Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TK3224IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_526)">
        <rect width="32" height="24" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24H32V0H0Z"
          fill="#2E42A5"
        />
        <mask
          id="mask0_1813_526"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="24"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H32V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_526)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.29448 10.0634L2.40892 10.6114L2.75272 9.69146L2 8.99504H2.913L3.29448 8L3.58559 8.99504H4.5L3.84101 9.69146L4.16365 10.6114L3.29448 10.0634Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.29448 6.06339L6.40892 6.61135L6.75272 5.69146L6 4.99504H6.913L7.29448 4L7.58559 4.99504H8.5L7.84101 5.69146L8.16365 6.61135L7.29448 6.06339Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2945 10.0634L10.4089 10.6114L10.7527 9.69146L10 8.99504H10.913L11.2945 8L11.5856 8.99504H12.5L11.841 9.69146L12.1637 10.6114L11.2945 10.0634Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.29448 14.0634L6.40892 14.6114L6.75272 13.6915L6 12.995H6.913L7.29448 12L7.58559 12.995H8.5L7.84101 13.6915L8.16365 14.6114L7.29448 14.0634Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.842 5.46313C20.7585 7.4803 7.34123 16.5452 7.34123 16.5452H29.6924C29.4691 16.4953 29.2609 16.4539 29.0645 16.4148C27.4238 16.0881 26.6138 15.9268 24.842 12.3971C22.8581 8.44501 24.842 5.46313 24.842 5.46313ZM6.61569 17.9652L6.31006 18.7251L6.61569 19.5601L29.3694 20.0001L30 18.8403L29.3694 18.0053L6.61569 17.9652Z"
            fill="#FECA00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_526">
          <rect width="32" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TK3224Icon;
